import React from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import onClickOutside from 'react-onclickoutside';
import classNames from 'classnames';

class Suggestions extends React.Component {
  state = {
    suggestions: []
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.entities.get('merchant').size > 0) {
      this._showSuggestions(nextProps.entities.get('merchant'));
    }
  }

  _hideSuggestions = () =>  {
    this.setState({ suggestions: [] });
  }

  _showSuggestions = (suggestions) => {
    this.setState({ suggestions: suggestions.valueSeq() });
  }

  _onSuggestionSelect(value, event) {
    event.preventDefault();

    if (this.alreadyConnected(value)) {
      return this.props.setValue(this.props.index, fromJS({ name: '' }));
    }

    if (this.props.setValue) {
      this.props.setValue(this.props.index, fromJS(value));
    }
    
    this.props.toggleSuggestions(false);
    this.props._search.selectSuggestion(value, this.props.inputClass !== 'search-source');
  }

  _onCreateSelect = (event) => {
    if(this.props.onCreateSelect) {
      this.props.onCreateSelect(this.props.index);
      this.props.toggleSuggestions(false);
    } else if (this.props.auth.get('user').get('isLoggedIn')) {
      this.props._plan.resetPlan();
      this.props.history.push('/plan')
    } else {
      this.props._auth.toggleAuthenticationModal(event, true);
      this.props.toggleSuggestions(false);
    }
  }

  handleClickOutside(event) {
    this.props.toggleSuggestions(false);
  }

  alreadyConnected = vendor => {
    const { entities } = this.props;

    const isConnected = entities
      .get('supplyNodes')
      .find(n => n.get('supplier_id') === vendor.get('vendor_id') || n.get('purchaser_id') === vendor.get('vendor_id'));

    const isPending = entities
      .get('supplyInvites')
      .find(i => i.get('invited_vendor_id') === vendor.get('vendor_id'));

    return this.props.inputClass === 'search-source' && (isConnected || isPending);
  }

  render() {
    const { createListingCopy } = this.props;
    const suggestions = this.state.suggestions.map((s, i) => {
      return <div className={classNames('search-suggestion', {
                    disabled: this.alreadyConnected(s)
                  })}
                  onClick={this._onSuggestionSelect.bind(this, s)}
                  key={i}>
                  {s.get('vendor').get('name')}<br/>
                  {s.get('line1')}<br/>
                  {s.get('locality')}, {s.get('region')}
      </div>;
    });

    return <div className='search-menu'
      style={this.props.showSuggestions ?
             { display: 'block' }:
             { display: 'none' }}>

      <div className="create-listing p-1">
        {createListingCopy ?
          createListingCopy
          :
          "Can't find your business?"
        }
        <button type="button" className="btn btn-primary btn-sm text-underline m-0 ml-2 p-1" onClick={this._onCreateSelect}>Add it!</button>
      </div>

      {suggestions}
    </div>;
  }
}

Suggestions.propTypes = {
  _search: PropTypes.object.isRequired,
  search: PropTypes.object.isRequired,
  showSuggestions: PropTypes.bool,
  toggleSuggestions: PropTypes.func.isRequired,
  createListingCopy: PropTypes.string,
};

export default onClickOutside(Suggestions);



// WEBPACK FOOTER //
// ./src/components/Search/Suggestions.js